import React, { useEffect, useState } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import NavIconHorizontal from './navIconHorizontal.component'
import { useDispatch, useSelector } from 'react-redux'
import {
  showInvoiceFormDialog,
  setTotalAssignments,
  setTotalApplications,
  setTotalWorkshifts
} from '../../actions'
import { getSelectedUser } from '../../selectors/adminUser.selector'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import classNames from 'classnames'
import {
  getApplicationData,
  getAppliedAssignmentId,
  getAppliedData,
  getAssignmentRows,
  getDirectlyOfferedAssignmentId,
  getUserData,
  getMyAssignmentRows,
  getWorkShiftUserRow
} from '../../selectors/openForWork.selector'
import {
  mergeAssignments,
  updateStatusData
} from '../../utils/openForWork.utils'

const styles = () => ({
  container: {
    padding: '15px',
    backgroundColor: '#44C0CC',
    width: 'var(--sidebar-width)'
  },
  header: {
    display: 'flex',
    color: '#fff',
    fontWeight: '500',
    marginBottom: '30px',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '20px'
  },
  userPhoto: {
    width: 'clamp(50px, 10vw, 100px)',
    height: 'clamp(50px, 10vw, 100px)',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#AEE0E7'
  },
  userInfo: {
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  navItem: {
    backgroundColor: '#AEE0E7',
    borderRadius: '15px',
    marginBottom: '15px',
    padding: '5px 15px 10px',
    '& > a': {
      textAlign: 'left !important'
    }
  },
  navItemOpenForWork: {
    backgroundColor: '#F67131',
    '& > a:hover': {
      color: '#fff !important'
    }
  },
  navItemOpenForWorkActive: {
    backgroundColor: '#fff',
    border: '4px solid #F67131',
    padding: '3px 11px 8px',
    '& > a': {
      color: '#F67131 !important'
    }
  },
  navLink: {
    color: '#fff',
    '&:hover': {
      transform: 'none !important'
    }
  },
  navLinkWithSubmenu: {
    display: 'flex !important',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontWeight: '500',
    padding: '5px 5px 0px 5px',
    transition: 'all 0.2s linear',
    color: '#fff',
    cursor: 'pointer',
    '&:hover': {
      color: '#F67131',
      transform: 'none !important'
    }
  },
  subMenuItem: {
    backgroundColor: '#AEE0E7',
    borderRadius: '15px',
    marginLeft: 'auto',
    marginBottom: '15px',
    padding: '5px 15px 10px',
    width: '80%'
  },
  navLinkActive: {
    color: '#F67131',
    '&:hover': {
      transform: 'none !important'
    }
  },
  navButton: {
    fontFamily: '"Poppins", sans-serif !important',
    fontWeight: '500',
    textAlign: 'center',
    border: 'none',
    background: 'none',
    color: '#fff',
    transition: 'all 0.2s linear',
    paddingTop: '5px',
    '&:hover': {
      color: '#F67131'
    },
    '&:disabled': {
      color: '#00000042',
      opacity: 0.65
    }
  }
})

const navItems = [
  {
    name: 'user',
    content: 'ETUSIVU',
    url: '/dashboard/main'
  },
  {
    name: 'users',
    content: 'ASIAKKAAT',
    url: '/dashboard/customer'
  },
  {
    name: 'sticky-note',
    content: 'LASKUT',
    url: '/dashboard/invoice',
    submenu: [
      {
        name: 'plus',
        content: 'UUSI_LASKUT'
      },
      {
        name: 'file-text',
        content: 'LUOMASI_LASKUT',
        url: '/dashboard/invoice#scroll-to-header'
      }
    ]
  },
  {
    name: 'newspaper-o',
    content: 'KULUT',
    url: '/dashboard/fee'
  },
  {
    name: 'credit-card',
    content: 'PALKAT',
    url: '/dashboard/salary'
  },
  {
    name: 'far fa-briefcase',
    content: 'OPENFORWORK',
    url: '/dashboard/openforwork/assignments'
  }
]

const SideNavigation = ({ classes, user }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const userType = useSelector((state) => state.client.user.data[5])
  const selectedUser = useSelector((state) => state.adminUser.selectedUser)
  const profileData = useSelector((state) => state.profile.userData)
  const clientData = user.data

  const loggedMail = useSelector(getUserData)[1]
  const directlyOfferedAssignmentId = new Set(
    useSelector(getDirectlyOfferedAssignmentId)
  )
  const assignmentRows = useSelector(getAssignmentRows).filter(
    (item) => !directlyOfferedAssignmentId?.has(item?.assignment_id)
  )
  const appliedAssignmentId = useSelector(getAppliedAssignmentId)
  const user_area_of_work = useSelector(getApplicationData)?.AreaOf_Work
  const appliedData = useSelector(getAppliedData)
  const myAssignmentRows = useSelector(getMyAssignmentRows)
  const workShiftUserRow = useSelector(getWorkShiftUserRow)

  const mergedAssignmentRows = mergeAssignments(assignmentRows, appliedData)
  const updatedAssignmentRows = updateStatusData(
    mergedAssignmentRows,
    appliedAssignmentId,
    loggedMail,
    user_area_of_work
  ).filter((el) => el.status !== 3) // Applied assignment

  const newAssignments = updatedAssignmentRows.filter(
    (el) => el.is_assignment_viewed === 0
  )

  const newApplications = myAssignmentRows.filter(
    (el) =>
      el.is_application_viewed === 0 &&
      el.agreement_status_entrepreneur === 'Offer sent by employer'
  )
  const newWorkShifts = workShiftUserRow.filter(
    (el) =>
      el.is_workshift_viewed === 0 && el.workshift_status_entrepreneur === 0
  )

  const totalNewAssignments = newAssignments.length
  const totalNewApplications = newApplications.length
  const totalNewWorkShifts = newWorkShifts.length

  React.useEffect(() => {
    dispatch(setTotalAssignments(totalNewAssignments))
    dispatch(setTotalApplications(totalNewApplications))
    dispatch(setTotalWorkshifts(totalNewWorkShifts))
  }, [totalNewAssignments, totalNewApplications, totalNewWorkShifts])

  const fullName = getFullName(userType, selectedUser, profileData, clientData)

  const [desktopView, setDesktopView] = useState(window.innerWidth > 768)

  useEffect(() => {
    const handleResize = () => {
      setDesktopView(window.innerWidth > 768)
    }

    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    desktopView && (
      <div className={classNames(classes.container, 'sidebar')}>
        <div style={{ position: 'sticky', top: '160px' }}>
          <div className={classes.header}>
            {/* <div className={classes.userPhoto}>user photo</div> */}
            <div className={classes.userInfo}>
              <p style={{ fontSize: '18px' }}>{fullName}</p>
              <ul className="nav">
                <li>
                  <NavLink to="/dashboard/profile" className={classes.navLink}>
                    {t('dashboard.asetu')}
                  </NavLink>
                </li>
                {user.data[5] === 1 && (
                  <li>
                    <NavLink to="/dashboard/admin" className={classes.navLink}>
                      {t('dashboard.hallinta')}
                    </NavLink>
                  </li>
                )}
              </ul>
            </div>
          </div>
          <NavigationItems
            classes={classes}
            navItems={navItems}
            totalNewAssignments={totalNewAssignments}
            totalNewApplications={totalNewApplications}
            totalNewWorkShifts={totalNewWorkShifts}
          />
        </div>
      </div>
    )
  )
}

const getFullName = (userType, selectedUser, profileData, clientData) => {
  const hasSelectedUser = selectedUser && Object.keys(selectedUser).length > 0
  const hasProfileData = profileData?.firstname && profileData?.lastname
  const defaultFullName = `${clientData[3]} ${clientData[4]}`

  if (userType === 2) {
    if (hasSelectedUser && !profileData) {
      return `${selectedUser.firstname} ${selectedUser.lastname}`
    }

    if (!hasSelectedUser) {
      return defaultFullName
    }

    if (hasProfileData) {
      return `${profileData.firstname} ${profileData.lastname}`
    }
  }

  if (hasProfileData) {
    return `${profileData.firstname} ${profileData.lastname}`
  } else {
    return defaultFullName
  }
}

const NavigationItems = ({
  classes,
  navItems,
  totalNewAssignments,
  totalNewApplications,
  totalNewWorkShifts
}) => {
  const dispatch = useDispatch()
  const location = useLocation()

  const userType = useSelector((state) => state.client.user.data[5])
  const selectedUser = useSelector(getSelectedUser)
  const noUserSelected = userType === 2 && !selectedUser?.email

  const isInvoiceActive = location.pathname.startsWith('/dashboard/invoice')
  const isOpenForWorkActive = location.pathname.startsWith(
    '/dashboard/openforwork'
  )

  return (
    <ul className="nav">
      {navItems.map((navItem, index) => (
        <React.Fragment key={index}>
          <li
            className={classNames(
              classes.navItem,
              navItem.content === 'OPENFORWORK'
                ? isOpenForWorkActive
                  ? classes.navItemOpenForWorkActive
                  : classes.navItemOpenForWork
                : null
            )}
          >
            {navItem.submenu ? (
              <NavLink
                to={navItem.url}
                className={`${isInvoiceActive ? classes.navLinkActive : ''} ${
                  classes.navLinkWithSubmenu
                }`}
              >
                <NavIconHorizontal
                  name={navItem.name}
                  content={navItem.content}
                  totalNewAssignments={totalNewAssignments}
                  totalNewApplications={totalNewApplications}
                  totalNewWorkShifts={totalNewWorkShifts}
                  size="2x"
                />
                <i
                  className={`fa fa-2x ${
                    isInvoiceActive ? 'fa-angle-up' : 'fa-angle-down'
                  }`}
                  aria-hidden="true"
                  style={{ marginLeft: '10px' }}
                ></i>
              </NavLink>
            ) : (
              <NavLink
                to={navItem.url}
                className={(isActive) =>
                  isActive ? classes.navLinkActive : classes.navLink
                }
              >
                <NavIconHorizontal
                  name={navItem.name}
                  content={navItem.content}
                  totalNewAssignments={totalNewAssignments}
                  totalNewApplications={totalNewApplications}
                  totalNewWorkShifts={totalNewWorkShifts}
                  size="2x"
                />
              </NavLink>
            )}
          </li>
          {navItem.submenu && isInvoiceActive && (
            <ul className="nav">
              {navItem.submenu.map((submenuItem, subIndex) => (
                <li key={subIndex} className={classes.subMenuItem}>
                  {submenuItem.url ? (
                    <NavLink
                      to={submenuItem.url}
                      className={
                        isInvoiceActive
                          ? classes.navLinkActive
                          : classes.navLink
                      }
                    >
                      <NavIconHorizontal
                        name={submenuItem.name}
                        content={submenuItem.content}
                        size="2x"
                      />
                    </NavLink>
                  ) : (
                    <button
                      className={classes.navButton}
                      onClick={() => dispatch(showInvoiceFormDialog())}
                      disabled={noUserSelected}
                    >
                      <NavIconHorizontal
                        name={submenuItem.name}
                        content={submenuItem.content}
                        size="2x"
                      />
                    </button>
                  )}
                </li>
              ))}
            </ul>
          )}
        </React.Fragment>
      ))}
    </ul>
  )
}

export default withStyles(styles)(SideNavigation)
